import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const RemoveButton = props => {
  const { adult, setModal, align } = props

  const handleClickRemove = () => {
    setModal({ id: `confirmDeletePickupPerson${adult.id}`, open: true })
  }

  return (
    <ResponsiveButton onClick={handleClickRemove} align={align}>
      Remove
    </ResponsiveButton>
  )
}

export default RemoveButton
